import React, {Component} from 'react';
import '../../../local_node_modules/react-select/dist/react-select.css';
import NumberFormat from "react-number-format";
import {deepCopyObject} from "../../../helper/helper";
import * as Decimal from "decimal.js";
import Alert from "react-s-alert";
import Select from "../../../local_node_modules/react-select";

class Costs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: {},
            costs: {
                recordId:null,
                calculateFromPercent:true,
                isTaxInclusive:true,
                komisyonPercentage: 0,
                komisyonTotal: 0,
                komisyonKdvPercentage: 0,
                komisyonKdvTotal: 0,
                navlunPercentage: 0,
                navlunTotal: 0,
                navlunKdvPercentage: 0,
                navlunKdvTotal: 0,
                hammaliyePercentage: 0,
                hammaliyeTotal: 0,
                hammaliyeKdvPercentage: 0,
                hammaliyeKdvTotal: 0,
                nakliyePercentage: 0,
                nakliyeTotal: 0,
                nakliyeKdvPercentage: 0,
                nakliyeKdvTotal: 0,
                gelirVTevkifatPercentage: 0,
                gelirVTevkifatTotal: 0,
                bagkurTevkifatPercentage: 0,
                bagkurTevkifatTotal: 0,
                halRusumuPercentage: 0,
                halRusumuTotal: 0,
                halRusumuKdvPercentage: 0,
                halRusumuKdvTotal: 0,
                ticBorsasiPercentage: 0,
                ticBorsasiTotal: 0,
                ticBorsasiKdvPercentage: 0,
                ticBorsasiKdvTotal: 0,
                milliSFonuPercentage: 0,
                milliSFonuTotal: 0,
                milliSFonuKdvPercentage: 0,
                milliSFonuKdvTotal: 0,
                digerPercentage: 0,
                digerTotal: 0,
                digerKdvPercentage: 0,
                digerKdvTotal: 0
            },
            taxInclusiveAmount:this.props.taxInclusiveAmount,
            taxExclusiveAmount:this.props.taxExclusiveAmount,

        };
        this.onChange = this.onChange.bind(this);
        this.calculateChange=this.calculateChange.bind(this);
        this.calculateAllValuesFromPercentage=this.calculateAllValuesFromPercentage.bind(this);
        this.onToggleTax = this.onToggleTax.bind(this);
        this.onCalculationMethodChange = this.onCalculationMethodChange.bind(this);
    }

    componentWillMount() {
        let self = this;
        if(this.props.brokerCosts) {
            let costs=deepCopyObject(this.props.brokerCosts);
            this.setState({costs},()=> this.props.listener(costs));

            if(costs.isTaxInclusive===null){
                costs.isTaxInclusive=true;
                this.setState({costs},()=> this.props.listener(costs));
            }
            if(costs.calculateFromPercent===null){
                costs.calculateFromPercent=true;
                this.setState({costs},()=> this.props.listener(costs));
            }
        }
    }

    onChange(e) {
        let {name, value} = e;
        let costs = this.state.costs;
        costs[name] = value;
        if(this.state.costs.calculateFromPercent) {
            this.calculateChange(name, value);
        }
        this.setState({costs},()=> this.props.listener(costs));
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if((nextProps.taxInclusiveAmount !== this.props.taxInclusiveAmount) ||
            (nextProps.taxExclusiveAmount !== this.props.taxExclusiveAmount) ||
            (nextProps.brokerCosts !== this.props.brokerCosts))
        {
            this.setState({taxInclusiveAmount : nextProps.taxInclusiveAmount,
                    taxExclusiveAmount : nextProps.taxExclusiveAmount,
                    costs : (nextProps.brokerCosts) ? nextProps.brokerCosts: this.state.costs},
                () => {
                    if(this.state.costs.calculateFromPercent){
                        this.calculateAllValuesFromPercentage();
                    }
                });
        }
    }

    calculateAllValuesFromPercentage() {
        let costs = this.state.costs;
        let totalName="";
        let totalNumber=0;
        let totalKdvName="";
        let totalKdvNumber=0;
        for (let [key, value] of Object.entries(this.state.costs)) {
            totalName = "";
            totalNumber = 0;
            if(key.toString().includes('Percentage') ) {
                totalName = key.toString().substring(0,key.toString().indexOf('Percentage')) +'Total';
                if (!key.toString().includes('Kdv')){
                    totalKdvName =key.toString().replace("Percentage","KdvTotal") ;
                    totalNumber = new Decimal((!(costs.isTaxInclusive) ? this.state.taxExclusiveAmount : this.state.taxInclusiveAmount)).toNumber() * new Decimal(value).toNumber() / new Decimal(100).toNumber() ;
                    if(!(key.toString().includes('gelirV') || key.toString().includes('bagkur'))) {
                        totalKdvNumber = new Decimal(totalNumber).toNumber() * new Decimal(costs[key.toString().replace("Percentage","KdvPercentage")]).toNumber() / new Decimal(100).toNumber() ;
                        costs[totalKdvName] = totalKdvNumber;
                    }
                }else{
                    totalNumber = new Decimal(costs[key.toString().replace("KdvPercentage","Total")]).toNumber() * new Decimal(value).toNumber() / new Decimal(100).toNumber() ;
                }
                costs[totalName] = totalNumber;
            }
        }
        this.setState({costs}, () => this.props.listener(costs));
    }

    calculateChange(name,value){
        let costs = this.state.costs;
        let totalName = "";
        let totalNumber = 0;
        let totalKdvName = "";
        let totalKdvNumber = 0;
        let percentName = "";
        let percentNumber = 0;
        let kdvPercentName = "";

        if(name.toString().includes('Percentage') ) {
            totalName = name.toString().substring(0,name.toString().indexOf('Percentage')) +'Total';

            if (!name.toString().includes('Kdv')){
                totalKdvName =name.toString().replace("Percentage","KdvTotal") ;
                totalNumber = new Decimal((!(costs.isTaxInclusive) ? this.state.taxExclusiveAmount : this.state.taxInclusiveAmount)).toNumber() * new Decimal(value).toNumber() / new Decimal(100).toNumber() ;
                if(!(name.toString().includes('gelirV') || name.toString().includes('bagkur'))) {
                    totalKdvNumber = new Decimal(totalNumber).toNumber() * new Decimal(costs[name.toString().replace("Percentage","KdvPercentage")]).toNumber() / new Decimal(100).toNumber() ;
                    costs[totalKdvName] = totalKdvNumber;
                }
            }else{
                totalNumber = new Decimal(costs[name.toString().replace("KdvPercentage","Total")]).toNumber() * new Decimal(value).toNumber() / new Decimal(100).toNumber() ;
            }
            costs[totalName] = totalNumber;
        }
        else if(name.toString().includes('Total')) {
            percentName = name.toString().substring(0, name.toString().indexOf('Total')) + 'Percentage';
            if (!name.toString().includes('Kdv')) {
                totalKdvName= name.toString().replace("Total","KdvTotal")
                kdvPercentName= name.toString().replace("Total","KdvPercentage")
                percentNumber = new Decimal(value).toNumber() / new Decimal((!(costs.isTaxInclusive) ? this.state.taxExclusiveAmount : this.state.taxInclusiveAmount)).toNumber() * new Decimal(100).toNumber();
                if(!(name.toString().includes('gelirV') || name.toString().includes('bagkur')) ) {
                    totalKdvNumber = new Decimal(value).toNumber() * new Decimal(costs[kdvPercentName]).toNumber() / new Decimal(100).toNumber();
                    costs[totalKdvName] = totalKdvNumber;
                }
            }else{
                totalName=  name.toString().replace("Kdv","");
                percentNumber = new Decimal(value).toNumber() / ( (new Decimal(costs[totalName]).toNumber()!==0) ? new Decimal(costs[totalName]).toNumber() :new Decimal(1).toNumber()) * new Decimal(100).toNumber();
            }
            costs[percentName] = percentNumber;
        }
        this.setState({costs},()=>this.props.listener(costs));
    }

    onToggleTax(e) {
        let self=this;
        let message = "";
        let costs = self.state.costs;
        let isTaxInclusive= !e.target.checked;
        costs.isTaxInclusive=isTaxInclusive;
        self.setState({costs}, () => this.calculateAllValuesFromPercentage());
        if (!e.target.checked) {
            message = "Masraflar KDV dahil hesaplanıyor.";
        } else {
            message = "Masraflar KDV hariç hesaplanıyor.";
        }
        Alert.info(message, {
            position: 'top-right',
            effect: 'stackslide',
            timeout: 3000,
            html: true
        });
    }

    onCalculationMethodChange(e){
        let self=this;
        let message="";
        let costs = self.state.costs;
        costs.calculateFromPercent=e.value;
        this.setState({costs},()=>this.props.listener(costs));
        if (costs.calculateFromPercent) {
            message = "Masraflar fiyat üzerinden oransal hesaplanacaktır.";
        } else {
            message = "Masraflar fiyat üzerinden oransal hesaplanmayacaktır.";
        }
        Alert.info(message, {
            position: 'top-right',
            effect: 'stackslide',
            timeout: 3000,
            html: true
        });
    }

    render() {
        let costs = this.state.costs;
        return (
            <div className="row">
                <div className="col-sm-12 row" style={{marginBottom:"10px"}}>

                    <label className="col-sm-3" style={{fontWeight:"bold"}}>Masraf Hesap Yöntemi</label>
                    <div className="col-sm-3">
                        <Select
                            clearable={false}
                            searchable={false}
                            className="select-control"
                            value={costs.calculateFromPercent}
                            placeholder="Seçiniz..."
                            onChange={e => this.onCalculationMethodChange(e)}
                            options={[{value:true,label:'Yüzde Girerek Hesaplama'},{value:false,label:'Manuel Giriş'}]}/>
                    </div>
                    {(costs.calculateFromPercent)  &&
                    <div className="col-sm-6">
                        <input type="checkbox" className="col-sm-1"
                               checked={((costs.isTaxInclusive===null) || (costs.isTaxInclusive===true)) ? false : true }
                               onChange={(e)=>this.onToggleTax(e)}/>

                        <label className="col-sm-6" style={{fontWeight:"bold"}}>Masrafları KDV Hariç Hesapla</label>
                    </div>
                    }
                </div>

                <div className="col-sm-12 row">
                    <label className="col-sm-2">Komisyon %: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="komisyonPercentage"
                                      value={costs.komisyonPercentage}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Komisyon %"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix="%"
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "komisyonPercentage"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Komisyon: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="komisyonTotal"
                                      value={costs.komisyonTotal}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Komisyon"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "komisyonTotal"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Komisyon Kdv %: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="komisyonKdvPercentage"
                                      value={costs.komisyonKdvPercentage}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Komisyon Kdv %"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix="%"
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "komisyonKdvPercentage"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Komisyon Kdv: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="komisyonKdvTotal"
                                      value={costs.komisyonKdvTotal}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Komisyon Kdv"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "komisyonKdvTotal"
                                      })}
                                      className="form-control"/>
                    </div>
                </div>

                <div className="col-sm-12 row">
                    <label className="col-sm-2">Navlun %: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="navlunPercentage"
                                      value={costs.navlunPercentage}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Navlun %"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix="%"
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "navlunPercentage"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Navlun: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="navlunTotal"
                                      value={costs.navlunTotal}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Navlun"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "navlunTotal"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Navlun Kdv %: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="navlunKdvPercentage"
                                      value={costs.navlunKdvPercentage}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Navlun Kdv %"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix="%"
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "navlunKdvPercentage"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Navlun Kdv: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="navlunKdvTotal"
                                      value={costs.navlunKdvTotal}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Navlun Kdv"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "navlunKdvTotal"
                                      })}
                                      className="form-control"/>
                    </div>
                </div>

                <div className="col-sm-12 row">
                    <label className="col-sm-2">Hammaliye %: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="hammaliyePercentage"
                                      value={costs.hammaliyePercentage}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Hammaliye %"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix="%"
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "hammaliyePercentage"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Hammaliye: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="hammaliyeTotal"
                                      value={costs.hammaliyeTotal}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Hammaliye"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "hammaliyeTotal"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Hammaliye Kdv %: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="hammaliyeKdvPercentage"
                                      value={costs.hammaliyeKdvPercentage}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Hammaliye Kdv %"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix="%"
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "hammaliyeKdvPercentage"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Hammaliye Kdv: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="hammaliyeKdvTotal"
                                      value={costs.hammaliyeKdvTotal}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Hammaliye Kdv"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "hammaliyeKdvTotal"
                                      })}
                                      className="form-control"/>
                    </div>
                </div>

                <div className="col-sm-12 row">
                    <label className="col-sm-2">Nakliye %: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="nakliyePercentage"
                                      value={costs.nakliyePercentage}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Nakliye %"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix="%"
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "nakliyePercentage"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Nakliye: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="nakliyeTotal"
                                      value={costs.nakliyeTotal}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Nakliye"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "nakliyeTotal"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Nakliye Kdv %: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="nakliyeKdvPercentage"
                                      value={costs.nakliyeKdvPercentage}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Nakliye Kdv %"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix="%"
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "nakliyeKdvPercentage"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Nakliye Kdv: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="nakliyeKdvTotal"
                                      value={costs.nakliyeKdvTotal}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Nakliye Kdv"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "nakliyeKdvTotal"
                                      })}
                                      className="form-control"/>
                    </div>
                </div>

                <div className="col-sm-12 row">
                    <label className="col-sm-2">Gelir V. %: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="gelirVPercentage"
                                      value={costs.gelirVTevkifatPercentage}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Gelir V. %"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix="%"
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "gelirVTevkifatPercentage"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Gelir V. Tevkifatı: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="gelirVTevkifatTotal"
                                      value={costs.gelirVTevkifatTotal}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Gelir V. Tevkifatı"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "gelirVTevkifatTotal"
                                      })}
                                      className="form-control"/>
                    </div>
                </div>

                <div className="col-sm-12 row">
                    <label className="col-sm-2">Bağkur Tevkifatı %: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="bagkurTevkitafPercentage"
                                      value={costs.bagkurTevkifatPercentage}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Bağkur Tevkifatı %"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix="%"
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "bagkurTevkifatPercentage"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Bağkur Tevkifatı: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="bagkurTevkifatTotal"
                                      value={costs.bagkurTevkifatTotal}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Bağkur Tevkifatı"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "bagkurTevkifatTotal"
                                      })}
                                      className="form-control"/>
                    </div>
                </div>

                <div className="col-sm-12 row">
                    <label className="col-sm-2">Hal Rüsumu %: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="halRusumuPercentage"
                                      value={costs.halRusumuPercentage}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Hal Rüsumu %"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix="%"
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "halRusumuPercentage"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Hal Rüsumu: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="halRusumuTotal"
                                      value={costs.halRusumuTotal}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Hal Rüsumu"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "halRusumuTotal"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Hal Rüsumu Kdv %: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="halRusumuKdvPercentage"
                                      value={costs.halRusumuKdvPercentage}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Hal Rüsumu Kdv %"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix="%"
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "halRusumuKdvPercentage"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Hal Rüsumu Kdv: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="halRusumuKdvTotal"
                                      value={costs.halRusumuKdvTotal}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Hal Rüsumu Kdv"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "halRusumuKdvTotal"
                                      })}
                                      className="form-control"/>
                    </div>
                </div>

                <div className="col-sm-12 row">
                    <label className="col-sm-2">Tic. Borsası %: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="ticBorsasiPercentage"
                                      value={costs.ticBorsasiPercentage}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Tic. Borsası %"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix="%"
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "ticBorsasiPercentage"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Tic. Borsası: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="ticBorsasiTotal"
                                      value={costs.ticBorsasiTotal}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Tic. Borsası"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "ticBorsasiTotal"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Tic. Borsası Kdv %: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="ticBorsasiKdvPercentage"
                                      value={costs.ticBorsasiKdvPercentage}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Tic. Borsası Kdv %"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix="%"
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "ticBorsasiKdvPercentage"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Tic. Borsası Kdv: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="ticBorsasiKdvTotal"
                                      value={costs.ticBorsasiKdvTotal}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Tic. Borsası Kdv"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "ticBorsasiKdvTotal"
                                      })}
                                      className="form-control"/>
                    </div>
                </div>

                <div className="col-sm-12 row">
                    <label className="col-sm-2">Milli S. Fonu %: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="milliSFonuPercentage"
                                      value={costs.milliSFonuPercentage}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Milli S. Fonu %"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix="%"
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "milliSFonuPercentage"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Milli S. Fonu: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="milliSFonuTotal"
                                      value={costs.milliSFonuTotal}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Milli S. Fonu"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "milliSFonuTotal"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Milli S. Fonu Kdv %: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="milliSFonuKdvPercentage"
                                      value={costs.milliSFonuKdvPercentage}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Milli S. Fonu Kdv %"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix="%"
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "milliSFonuKdvPercentage"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Milli S. Fonu Kdv: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="milliSFonuKdvTotal"
                                      value={costs.milliSFonuKdvTotal}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Milli S. Fonu Kdv"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "milliSFonuKdvTotal"
                                      })}
                                      className="form-control"/>
                    </div>
                </div>

                <div className="col-sm-12 row">
                    <label className="col-sm-2">Diğer %: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="digerPercentage"
                                      value={costs.digerPercentage}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Diğer %"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix="%"
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "digerPercentage"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Diğer: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="digerTotal"
                                      value={costs.digerTotal}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Diğer"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "digerTotal"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Diğer Kdv %: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="digerKdvPercentage"
                                      value={costs.digerKdvPercentage}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Diğer Kdv %"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix="%"
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "digerKdvPercentage"
                                      })}
                                      className="form-control"/>
                    </div>
                    <label className="col-sm-2">Diğer Kdv: </label>
                    <div className="col-sm-1">
                        <NumberFormat id="digerKdvTotal"
                                      value={costs.digerKdvTotal}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      allowEmptyFormatting={false}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      displayType="input"
                                      isAllowed={values => {
                                          return (values.value !== "");
                                      }}
                                      placeholder="Diğer Kdv"
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      onValueChange={(e) => this.onChange({
                                          value: e.value,
                                          name: "digerKdvTotal"
                                      })}
                                      className="form-control"/>
                    </div>
                </div>
            </div>
        );
    }
}

export default Costs;